export const waitMillis = (millis: number) => {
  return new Promise<void>((resolve) => setTimeout(resolve, millis))
}
